// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { ProgressBar } from './task-progress-bar';

/**
 * @class Jsw.ScheduledTasks.OutputPopup
 * @extends Jsw.Task.ProgressBar.OutputPopup
 */
export const ScheduledTasks = {};
ScheduledTasks.OutputPopup = Class.create(ProgressBar.OutputPopup, {
    _initConfiguration($super, config) {
        let titleMessage = '';
        let titleClass = '';
        if (config.result) {
            titleMessage = 'popupDone';
            titleClass = 'hint-ok';
        } else {
            titleMessage = 'popupError';
            titleClass = 'hint-failed';
        }
        titleMessage = this.lmsg(titleMessage, {
            task: config.name,
            seconds: config.seconds,
        });

        const title = `<div><p><span class="${titleClass}"><b>${titleMessage}</b></span></p></div>`;
        this._content = title + this._content;

        $super(config);
    },
});



// WEBPACK FOOTER //
// ./jsw/scheduled-tasks.js